import { FC, useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { useUrlState, TrackingEvent, Flag, useIsFeatureFlagOn } from "@ncs/web-legos"
import { useShopContext } from "~/contexts"
import { PageContentWrapper, PartPreviewRowEcomm, PartPreviewRow } from "~/shared-components"
import { BrandCtaGridEcomm, OrderReceivedModalEcomm, ShopCarousel } from "./components"
import { useAnalytics } from "~/hooks/useAnalytics"

export type ShopUrlState = {
	fromOrder: string | null
	shippingMethod?: string | null
}

export const ShopEcomm: FC = () => {
	const isEcommServiceAPIEnabled =
		useIsFeatureFlagOn(Flag.ECOMM_SERVICE_API) && !localStorage["Legacy"]

	const history = useHistory()
	const [{ recentlyViewedPartIds }] = useShopContext()

	// If we're redirected here from checkout after finishing an order, show confirmation.
	const [{ fromOrder, shippingMethod }] = useUrlState<ShopUrlState>({
		fromOrder: null,
		shippingMethod: null,
	})
	const [showOrderReceivedModal, setShowOrderReceivedModal] = useState(false)
	const { trackEvent } = useAnalytics()
	const handleAddToCart = (id: string) => {
		trackEvent(TrackingEvent.RV_ADD_TO_CART)
	}

	useEffect(() => {
		if (fromOrder) {
			setShowOrderReceivedModal(true)
			trackEvent(TrackingEvent.CONGRATS)
		}
	}, [fromOrder])

	return (
		<PageContentWrapper breadcrumbs={[{ name: "Shop" }]} title="Shop">
			<ShopCarousel />

			<BrandCtaGridEcomm />

			{recentlyViewedPartIds.length > 0 &&
				(isEcommServiceAPIEnabled ?
					<PartPreviewRow
						heading="Recently Viewed Products"
						partIds={recentlyViewedPartIds}
						onAddToCart={handleAddToCart}
					/>
				:	<PartPreviewRowEcomm
						heading="Recently Viewed Products"
						partIds={recentlyViewedPartIds}
						onAddToCart={handleAddToCart}
					/>)}

			<OrderReceivedModalEcomm
				isOpen={showOrderReceivedModal}
				onClose={() => {
					setShowOrderReceivedModal(false)
					history.replace("/shop")
				}}
				orderNumber={fromOrder}
				shippingMethod={shippingMethod ?? undefined}
			/>
		</PageContentWrapper>
	)
}
